import apiClient from '../apiClient';
import { DEFAULT_PIPEEX_PROFILE_NAME } from '../../config/defaultPipeexProfile/defaultPipeexProfile';
import {
  getSettingsTypeWireVariants,
  isAuthFailureError,
  isRetryableSettingsTypeContractError,
  normalizeScopedProfileName,
  normalizeSettingsType,
} from './pcfSettingsSerialization';
import type { SettingsType } from './pcfSettingsTypes';

export async function renamePipeexSettings(
  currentName: string,
  newName: string,
  settingsType: SettingsType
): Promise<void> {
  const normalizedSettingsType = normalizeSettingsType(settingsType);
  const normalizedCurrentName = normalizeScopedProfileName(
    currentName,
    normalizedSettingsType,
    DEFAULT_PIPEEX_PROFILE_NAME
  );
  const normalizedNewName = newName.trim();
  if (!normalizedNewName) {
    throw new Error('Profile name is required');
  }

  let lastError: unknown = null;
  const wireVariants = getSettingsTypeWireVariants(normalizedSettingsType);
  for (let i = 0; i < wireVariants.length; i += 1) {
    try {
      await apiClient.put('/pcf_settings/rename', {
        currentName: normalizedCurrentName,
        newName: normalizedNewName,
        settingsType: wireVariants[i],
      }, { timeout: 10000 });
      return;
    } catch (error) {
      lastError = error;
      if (i < wireVariants.length - 1 && isRetryableSettingsTypeContractError(error)) {
        continue;
      }
      break;
    }
  }

  if (isAuthFailureError(lastError)) {
    throw lastError ?? new Error('Authentication failed while renaming settings profile');
  }

  throw lastError ?? new Error('Failed to rename settings profile');
}
